/**
 * Normalize question_schema for backend storage and form-filler display.
 * For slider questions with hideValueFromFiller: true, sets showLabels: false and
 * tooltipVisibility: "never" so the value is not shown to the respondent but is still saved.
 * @param {Object} schema - SurveyJS survey JSON (with pages[].elements)
 * @returns {Object} Normalized schema (shallow copy with normalized elements)
 */
export function normalizeQuestionSchemaForBackend(schema) {
  if (!schema || !schema.pages || !Array.isArray(schema.pages)) return schema;
  const pages = schema.pages.map((page) => {
    if (!page.elements || !Array.isArray(page.elements)) return page;
    const elements = page.elements.map((el) => {
      if (el.type === "slider" && el.hideValueFromFiller === true) {
        return {
          ...el,
          showLabels: false,
          tooltipVisibility: "never",
        };
      }
      return el;
    });
    return { ...page, elements };
  });
  return { ...schema, pages };
}

/**
 * When loading schema into the creator, set hideValueFromFiller: true for sliders
 * that already have showLabels: false and tooltipVisibility: "never" (e.g. from a previous save).
 * @param {Object} schema - SurveyJS survey JSON
 * @returns {Object} Schema with hideValueFromFiller set for matching sliders
 */
export function ensureSliderHideValueFlagForCreator(schema) {
  if (!schema || !schema.pages || !Array.isArray(schema.pages)) return schema;
  const pages = schema.pages.map((page) => {
    if (!page.elements || !Array.isArray(page.elements)) return page;
    const elements = page.elements.map((el) => {
      if (
        el.type === "slider" &&
        el.showLabels === false &&
        el.tooltipVisibility === "never" &&
        el.hideValueFromFiller !== true
      ) {
        return { ...el, hideValueFromFiller: true };
      }
      return el;
    });
    return { ...page, elements };
  });
  return { ...schema, pages };
}
